export default function hero ($) {

    const body = $('body');
	// Run Hero video function only on pages where it exists  (Home/Producer/Shows/CS Shows)
	if (body.hasClass("home") || body.hasClass("single-producer") || body.hasClass("single-show") || body.hasClass("single-cs-show") ) {
        $('#hero-video').on('click', function(){
            if(this.paused == false){
                this.pause();
            } else{
                this.play();
            }    

        })
}

}